import tracer from 'dd-trace'
import { isTraceableEnvironment } from './is-traceable-environment'

export const getTraceId = () =>
  isTraceableEnvironment() ? tracer.scope().active()?.context().toTraceId() : ''
